import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, DownloadIcon, LockIcon } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout, trackViewContent } from '../utils/metaPixel';
import { OfferCountdown } from './OfferCountdown';
const CART_URL = 'https://checkout.volveaserdeseada.com/cart/add?id=42732657344599&quantity=1&return_to=%2Fcart';
interface OfferSectionProps {
  ctaText?: string;
}
export function OfferSection({
  ctaText = 'Quiero volver a sentirme deseada →'
}: OfferSectionProps) {
  return <section className="py-16 md:py-24 px-4" data-id="element-127">
      <div className="max-w-6xl mx-auto space-y-[12px]" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} onViewportEnter={() => trackViewContent()} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-129">
          <div className="inline-block bg-burgundy text-white px-6 py-3 rounded-full mb-6 pt-[13px] pb-[13px]" data-id="element-130">
            <p className="font-bold text-[20px]" data-id="element-131">⚡️OFERTA ESPECIAL</p>
          </div>
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-burgundy mb-6" data-id="element-132"></h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-134">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/8iAEAMoKWG6by7j5WS1DB8/foto_de_la_web.png" alt="LUMEIA — Volvé a ser deseada · Producto + 7 bonus de regalo" className="w-full h-auto" data-id="element-136" />
              <div className="absolute top-4 right-4 bg-gold text-white px-4 py-2 rounded-full font-bold shadow-lg" data-id="element-137">
                50% OFF
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-138">
            <div className="bg-white/80 backdrop-blur-sm p-8 md:p-10 rounded-2xl shadow-xl" data-id="element-139">
              <p className="text-charcoal/60 text-lg mb-2" data-id="element-140">Valor normal:</p>
              <p className="text-3xl font-bold text-charcoal/40 line-through mb-4" data-id="element-141">
                $30.000 ARS
              </p>

              <p className="text-burgundy text-lg font-semibold mb-2" data-id="element-142">
                Precio hoy:
              </p>
              <p className="text-5xl md:text-6xl font-bold text-burgundy mb-2" data-id="element-143">
                $14.999
              </p>
              <p className="text-lg font-semibold text-[#C8963E] mb-6" data-id="element-144">
                + 7 bonus incluidos
              </p>

              <div className="space-y-3 mb-8" data-id="element-145">
                <div className="flex items-center gap-3 text-charcoal/80" data-id="element-146">
                  <ZapIcon className="w-5 h-5 text-burgundy" data-id="element-147" />
                  <span data-id="element-148">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-3 text-charcoal/80" data-id="element-149">
                  <DownloadIcon className="w-5 h-5 text-burgundy" data-id="element-150" />
                  <span data-id="element-151">Descarga digital</span>
                </div>
                <div className="flex items-center gap-3 text-charcoal/80" data-id="element-152">
                  <ShieldCheckIcon className="w-5 h-5 text-burgundy" data-id="element-153" />
                  <span data-id="element-154">Garantía 7 días</span>
                </div>
              </div>

              {/* Elegant 20-min countdown above the CTA */}
              <div className="mb-6 pb-6 border-b border-burgundy/10" data-id="element-155">
                <OfferCountdown data-id="element-156" />
              </div>

              <button onClick={() => {
              trackAddToCart();
              trackInitiateCheckout();
              window.location.href = CART_URL;
            }} className="block w-full bg-burgundy hover:bg-burgundy/90 text-white font-bold text-xl py-5 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-157">
                {ctaText}
              </button>
              <div className="flex items-center justify-center gap-4 text-sm text-charcoal/60 mt-4" data-id="element-158">
                <LockIcon className="w-4 h-4" data-id="element-159" />
                <span data-id="element-160">Pago seguro</span>
                <span data-id="element-161">•</span>
                <span data-id="element-162">Visa • Mastercard • Mercado Pago</span>
              </div>
            </div>

            <div className="mt-6 bg-burgundy/5 p-6 rounded-xl border-2 border-burgundy/20" data-id="element-163">
              <div className="flex items-start gap-3" data-id="element-164">
                <ShieldCheckIcon className="w-6 h-6 text-burgundy flex-shrink-0 mt-1" data-id="element-165" />
                <div data-id="element-166">
                  <p className="font-bold text-burgundy mb-2" data-id="element-167">
                    🛡️ Garantía 7 Días
                  </p>
                  <p className="text-sm text-charcoal/70" data-id="element-168">
                    Probalo sin riesgo. Si no te aporta valor, te devolvemos tu
                    dinero.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}